<template>
  <div class="flex items-center gap-2 px-2.5 py-1 rounded-xl bg-slate-50 dark:bg-slate-800/60 border border-slate-200/60 dark:border-slate-800 shrink-0">
    <div class="w-6 h-6 rounded-lg bg-white dark:bg-slate-750 flex items-center justify-center shrink-0 shadow-2xs">
      <component
        :is="icon"
        class="w-3.5 h-3.5"
        :class="iconColor"
      />
    </div>
    <div class="text-left min-w-0">
      <div class="text-xs font-extrabold text-slate-900 dark:text-white leading-tight truncate">{{ value }}</div>
      <div class="text-[10px] text-slate-500 dark:text-slate-400 font-medium leading-none mt-0.5 truncate">{{ label }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MiniStat",
    props: {
      icon: {
        type: [Object, Function],
        required: true,
      },
      value: {
        type: [String, Number],
        required: true,
      },
      label: {
        type: String,
        required: true,
      },
      iconColor: {
        type: String,
        default: "text-indigo-600",
      },
    },
  };
</script>
